import { render, staticRenderFns } from "./viewDetails.vue?vue&type=template&id=cee0758e&lang=pug&"
import script from "./viewDetails.vue?vue&type=script&lang=js&"
export * from "./viewDetails.vue?vue&type=script&lang=js&"
import style0 from "./viewDetails.vue?vue&type=style&index=0&id=cee0758e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports